export default __webpack_public_path__ + "static/media/1553.b0054b41.png";